import { Workbook } from "exceljs";
import { tx } from "../common/excel-event";
import { excelLocation } from "../location/location-item";
import {
  buildGroupByPointIdMap,
  normalizePointId
} from "../common/point-id-index";

export const excelSheetEvent = (
  t: any,
  workbook: Workbook,
  sheetNum: number,
  locationsTable: any[],
  eventResult: any[],
  eventLegend: any[]
) => {
  const worksheet = workbook.getWorksheet(sheetNum);

  if (!worksheet) {
    return;
  }

  const dataItem = excelLocation(worksheet, t, locationsTable);

  if (!dataItem || dataItem.length === 0) {
    return;
  }

  if (eventResult && eventResult.length && eventLegend && eventLegend.length) {
    tx("AE", eventLegend[0].layerInfo.name, worksheet, 1, null);
    tx("AF", "Intensity Value", worksheet, 1, t);
  }

  if (!eventResult || !eventResult.length) {
    return;
  }

  const eventByPointId = buildGroupByPointIdMap(
    eventResult,
    (eventItem: any) => eventItem?.pointId
  );

  dataItem.forEach((item: any, i: number) => {
    const dataEventFinded = eventByPointId.get(normalizePointId(item?.id))?.[0];

    if (!dataEventFinded) {
      return;
    }

    tx("AE", dataEventFinded.valueLabel, worksheet, i + 2, t);
    tx("AF", dataEventFinded.intensity, worksheet, i + 2, t);
  });
};
